import CheckoutModalPresenter from './checkoutModalPresenter';
import checkoutModalTypes from './checkoutModalTypes';
import CheckoutLesson from './lesson/checkoutLesson';
import CheckoutMaterial from './material/checkoutMaterial';
import CheckoutSeminar from './seminar/checkoutSeminar';
import { useLocation } from '@reach/router';
import ModalLayout, {
  closeTimeoutMS,
  defaultModalStyles,
} from '@src/components/layout/modalLayout';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactModal from 'react-modal';
import { Box, Button } from 'theme-ui';

const checkoutModal = ({ subjects }) => {
  const { t, i18n } = useTranslation();

  const checkoutModalPresenter = new CheckoutModalPresenter();
  const location = useLocation();
  const [modalVm, setModalVm] = useState({});
  useEffect(() => {
    const updateView = (generatedVm) => {
      setModalVm(generatedVm);
    };
    checkoutModalPresenter.loadModalState(updateView);
    return updateView;
  }, []);

  useEffect(() => {
    checkoutModalPresenter.closeModal();
  }, [location]);

  const onClose = () => {
    checkoutModalPresenter.toggleModal();
  };

  return (
    <ReactModal
      isOpen={modalVm.isOpen}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      ariaHideApp={false}
      onRequestClose={onClose}
      closeTimeoutMS={closeTimeoutMS}
      style={defaultModalStyles}
    >
      <ModalLayout>
        <Box py={4}>
          <Box
            bg="white"
            sx={{
              position: 'relative',
              borderRadius: '20px',
              overflow: 'hidden',
              boxShadow: '0px 10px 30px #0000001A',
            }}
          >
            <Button
              variant="empty"
              onClick={onClose}
              type="button"
              sx={{
                padding: '8px',
                position: 'absolute',
                top: ['10px', '30px'],
                right: ['10px', '30px'],
                fontSize: '14px',
                color: 'label',
              }}
            >
              {t('close')}
            </Button>

            {modalVm.modalType === checkoutModalTypes.lesson.type && (
              <CheckoutLesson />
            )}

            {modalVm.modalType === checkoutModalTypes.material.type && (
              <CheckoutMaterial />
            )}

            {modalVm.modalType === checkoutModalTypes.seminar.type && (
              <CheckoutSeminar />
            )}
          </Box>
        </Box>
      </ModalLayout>
    </ReactModal>
  );
};

export default checkoutModal;
